import React from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';

export const isTokenValid = (token: string | null): boolean => {
    if (!token) return false;
    try {
        const parts = token.split('.');
        if (parts.length !== 3) return false;

        // Decode payload
        const payload = JSON.parse(atob(parts[1]));
        if (payload.exp && typeof payload.exp === 'number') {
            // Check if token has expired
            if (Date.now() >= payload.exp * 1000) {
                return false;
            }
        }
        return true;
    } catch (e) {
        return false;
    }
};

export const getUserFromToken = (token: string | null): { id?: number; name?: string; email?: string; role?: string } | null => {
    if (!token) return null;
    try {
        const parts = token.split('.');
        if (parts.length !== 3) return null;
        return JSON.parse(atob(parts[1]));
    } catch {
        return null;
    }
};

export const SuperAdminRoute: React.FC = () => {
    const token = localStorage.getItem('khazanah_token');
    const user = getUserFromToken(token);

    // Hanya izinkan akses jika role adalah superadmin
    if (!user || user.role !== 'superadmin') {
        return <Navigate to="/admin/dashboard" replace />;
    }

    return <Outlet />;
};

const ProtectedRoute: React.FC = () => {
    const location = useLocation();
    const token = localStorage.getItem('khazanah_token');

    const isValid = isTokenValid(token);

    if (!isValid) {
        if (token) {
            localStorage.removeItem('khazanah_token');
        }
        return <Navigate to="/admin/login" state={{ from: location }} replace />;
    }

    return <Outlet />;
};

export default ProtectedRoute;
